var iframeSandbox = "allow-forms allow-popups allow-same-origin  allow-scripts  allow-top-navigation-by-user-activation";
var baseApplePath = 'music.apple.com/';
var baseEmbeddedPath = 'https://embed.music.apple.com/';
var createEmbeddedLink = function (link) {
    var finalPath = link.split(baseApplePath)[1];
    return baseEmbeddedPath + "/" + finalPath;
};
var getHeight = function (link) {
    return link.includes('i=') ? 150 : 450;
};
export var appleMusic = {
    category: 'AUDIO',
    isSatisfied: function (link) { return link.includes(baseApplePath); },
    getPlayerExecutionProps: function (link) { return ({
        link: createEmbeddedLink(link),
        allowProps: 'autoplay *; encrypted-media *; fullscreen *',
        sandbox: iframeSandbox,
        height: getHeight(link),
        responsive: true,
        css: {
            width: '100%',
            maxWidth: '660px',
            overflow: 'hidden',
            background: 'transparent',
        },
    }); },
};
